/* eslint-disable */
import { HiX } from 'react-icons/hi';
import Links from './components/Links';
import {
  renderThumb,
  renderTrack,
  renderView,
  renderViewMini,
} from 'components/scrollbar/Scrollbar';
import { Scrollbars } from 'react-custom-scrollbars-2';
import avatar4 from 'assets/img/avatars/avatar4.png';
import defaultRoutes from 'routes';
import Card from 'components/card';
import { SIDEBAR_DESKTOP_BREAKPOINT } from 'pages/Hooks/useSidebarOpen';
import React, { useContext, useEffect } from 'react';
import { AuthContext } from 'contexts/AuthContext';
import ProfilePic from 'pages/Student/Profile/ProfilePic/ProfilePic';

function SidebarHorizon(props) {
  const { state } = useContext(AuthContext);
  const {
    open,
    onClose,
    variant,
    mini,
    hovered,
    setHovered,
    routes = defaultRoutes,
  } = props;
  const [displayName, setDisplayName] = React.useState('');
  const { user } = state;

  useEffect(() => {
    if (user) {
      if (user?.role === 'admin' && user?.username) {
        setDisplayName(user?.username);
      } else if (user?.name) {
        setDisplayName(user?.name);
      } else {
        setDisplayName('Anonymous');
      }
    }
  }, [user]);
  const handleMouseEnter = () => {
    if (typeof setHovered === 'function') {
      setHovered(true);
    }
  };

  const handleMouseLeave = () => {
    if (typeof setHovered === 'function') {
      setHovered(false);
    }
  };
  return (
    <div
      className={`sm:none ${
        mini === false
          ? 'w-[285px]'
          : mini === true && hovered === true
          ? 'w-[285px]'
          : 'w-[285px] lg:!w-[120px]'
      } duration-175 linear fixed !z-50 min-h-full transition-all md:!z-50 lg:!z-0 ${
        variant === 'auth' ? 'lg:hidden' : 'lg:block'
      } ${open ? '' : '-translate-x-[105%]'}`}
      onMouseEnter={() => handleMouseEnter(true)}
      onMouseLeave={() => handleMouseLeave(false)}
    >
      <Card
        extra={`ml-3 w-full h-[96.5vh] sm:mr-4 sm:my-4 m-7 !rounded-[20px]`}
      >
        <Scrollbars
          autoHide
          renderTrackVertical={renderTrack}
          renderThumbVertical={renderThumb}
          renderView={
            mini === false
              ? renderView
              : mini === true && hovered === true
              ? renderView
              : renderViewMini
          }
        >
          <div className="flex h-full flex-col justify-between pt-4">
            <div>
              <span
                className="absolute absolute right-3 top-3 block h-5 w-5 cursor-pointer text-gray-900 dark:text-white lg:hidden"
                onClick={onClose}
              >
                <HiX />
              </span>
              <div
                className={`m-auto mb-auto flex items-center justify-center pb-0 text-center font-poppins text-[20px] font-bold text-navy-700 dark:text-white ${
                  mini === false ||
                  (mini === true && hovered === true) ||
                  (mini === true && window.innerWidth < SIDEBAR_DESKTOP_BREAKPOINT)
                    ? 'block'
                    : 'hidden'
                }`}
                style={{
                  whiteSpace: 'wrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                Welcome, {state?.user?.name} <br />
              </div>
              {['superadmin', 'headhr', 'jrhr', 'hr'].includes(
                state?.user?.role
              ) ? null : (
                <div className="pb-4">
                  <div className=" text-navy-800 dark:text-white">
                    <div className=" flex justify-center text-gray-600 dark:text-gray-400">
                      <span className="text-sm font-bold">Branch :&nbsp;</span>
                      <span className="text-sm font-bold">
                        {state?.user?.branch?.name?.charAt(0).toUpperCase() +
                          state?.user?.branch?.name?.slice(1) ||
                          'Branch Name Unavailable'}
                        (
                      </span>
                      <span className="text-sm font-bold">
                        {state?.user?.branch?.location
                          ?.charAt(0)
                          .toUpperCase() +
                          state?.user?.branch?.location?.slice(1) ||
                          'Location Unavailable'}
                        )
                      </span>
                    </div>
                  </div>
                </div>
              )}
              <div
                className={`m-auto mb-auto flex items-center justify-center pb-2 text-center font-poppins text-[22px] font-bold uppercase text-navy-700 dark:text-white ${
                  mini === false ||
                  (mini === true && hovered === true) ||
                  (mini === true && window.innerWidth < SIDEBAR_DESKTOP_BREAKPOINT)
                    ? 'hidden'
                    : 'block'
                }`}
              >
                {state?.user?.name?.charAt(0)}
              </div>

              <div className="mb-7 mt-[0px] h-px bg-gray-200 dark:bg-white/10" />
              {/* Nav item */}
              <ul>
                <Links mini={mini} hovered={hovered} routes={routes} onClose={onClose} />
              </ul>
            </div>
            {/* Free Horizon Card    */}
            <div className="mb-[30px] mt-[28px]">
              <div className="flex justify-center ">
                {/* <SidebarCard mini={mini} hovered={hovered} /> */}
              </div>
              {/* Sidebar profile info */}
              <div className="mb-0 mt-0  flex items-center justify-center gap-3">
                <div className="w-15 h-full rounded-full bg-blue-200">
                  {state?.user?.role === 'student' ? (
                    <ProfilePic />
                  ) : (
                    <img
                      src={avatar4}
                      className="h-10 w-10 rounded-full object-cover"
                      alt="avatar"
                    />
                  )}
                </div>
                <div
                  className={`ml-1 ${
                    mini === false
                      ? 'block'
                      : mini === true && hovered === true
                      ? 'block'
                      : 'block lg:hidden'
                  }`}
                >
                  <h4 className="text-base font-bold text-navy-700 dark:text-white">
                    {displayName}
                  </h4>
                  <p className="text-sm font-medium text-gray-600">
                    Role :{' '}
                    {user?.role === 'account'
                      ? 'Accountant'
                      : user?.role?.charAt(0).toUpperCase() +
                        user?.role?.slice(1)}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Scrollbars>
      </Card>
    </div>
  );
}

export default SidebarHorizon;
